import React from 'react'
import { SellMoreScreen } from "~/components/common/sell-more-screen";
import { Calls } from "~/components/pages/features/components/calls";
import { Mobile } from "~/components/pages/features/components/mobile";
import { Business } from "~/components/pages/features/components/business";
import { Marketing } from "~/components/pages/features/components/marketing";
import { Integrations } from "~/components/pages/features/components/integrations";
import { WebHooks } from "~/components/pages/features/components/webhooks";
import * as Styled from "./styled";

export const Features: React.FC = (props) => {
  return (
    <div className='onlinepbx__features'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container__feature'>
          <>
            <Styled.BackgroundCircle1 src={`${process.env.PUBLIC_DIR}/images/features-page/background_circle_1.svg`} alt='' />
            <Styled.BackgroundCircle2 src={`${process.env.PUBLIC_DIR}/images/features-page/background_circle_2.svg`} alt='' />
            <Styled.BackgroundCircle1_2 src={`${process.env.PUBLIC_DIR}/images/features-page/background_circle_1(2).svg`} alt='' />
            <Styled.BackgroundRectangle1 src={`${process.env.PUBLIC_DIR}/images/features-page/background_rectangle_1.svg`} alt='' />
            <Styled.BackgroundCircle3 src={`${process.env.PUBLIC_DIR}/images/features-page/background_circle_3.svg`} alt='' />
            <Styled.BackgroundCircle4 src={`${process.env.PUBLIC_DIR}/images/features-page/background_circle_4.svg`} alt='' />
            <Styled.BackgroundCircleSmall src={`${process.env.PUBLIC_DIR}/images/features-page/background_circle_4(2).svg`} alt='' />
            <Styled.BackgroundRectangle2 src={`${process.env.PUBLIC_DIR}/images/features-page/background_rectangle_2.svg`} alt='' />
          </>
          <h1 className='onlinepbx__feature__content__header__center'>
            Возможности
          </h1>
          <Calls />
          <Mobile />
          <Business />
          <Marketing />
          <Integrations />
          <WebHooks />
        </div>
      </div>
      <div className="onlinepbx__sel__more">
        <SellMoreScreen />
      </div>
    </div>
  )
}

export default Features
